import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext';
import BackLoader from '../components/backloader';
import JisButton from '../components/controls/jisButton';


function MyDraftCases() {

    const navigate = useNavigate();
    const {  activePage, token, profile,frequentData, setIsExpired} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
      useEffect(() => {
          onLoad();       
    }, []);

     const onLoad= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-my-draft`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setCases(data.cases)

            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
const onContinue=(caseid)=>{
    navigate(`/case-filing/${caseid}`)
}
  return (
    <div>
      
      
<div className='table'>
  <div class="section-cases">
  <span>My Draft Cases</span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Date Filed</th>
      <th>Status Level</th>
  
      <th>Resume Filing</th>
    </tr>
  </thead>
  <tbody>
     {cases.map((opt, index) => (
       <tr key={index}>
      <td>{opt.referenceNumber}</td>
      <td>{opt.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
            <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
            <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
      <td>Case is Draft Mode</td>
      <td><JisButton variant='plain' onClick={()=>onContinue(opt.caseId)}>Continue</JisButton></td>
    </tr>
    ))} 
    


  </tbody>
</table>
</div>
<BackLoader open={loading} />
    </div>
  );
}

export default MyDraftCases;